import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TrainingForm from './TrainingForm';
import { AppDispatch, RootState } from "../../store/configureStore";
import { addTraining } from "../../actions/trainingActions.js"; // Use addTraining explicitly
import Training from '../../types/Training';

const AddTraining: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>(); // Use typed dispatch
  const loggedInUser = useSelector((state: RootState) => state.loggedInUser);

  const hoursCoeff = 1000 * 60 * 60; // round to hours
  const [trainingData, setTrainingData] = useState<Training | null>(null);

  // Prepare default training data for new entries
  useEffect(() => {
    if (loggedInUser) {
      setTrainingData({
        id: null, // New training uses ID null
        userId: loggedInUser.id,
        trainingDate: new Date(Math.round(new Date().getTime() / hoursCoeff) * hoursCoeff),
        name: '',
        trainingType: 'RUNNING',
        description: '',
        distance: 0,
        elevationGain: 0,
        checkpointCount: 0,
        isDeleted: false,
        trainingParts: [],
        trainingPeriodId: null, // Default to no period
      });
    }
  }, [loggedInUser]);

  // Save using 'addTraining' endpoint for new entries
  const saveTrainingToDB = async (trainingToSave: Training) => {
    console.log("Creating new training: ", trainingToSave);
    await dispatch(addTraining(trainingToSave)); // Explicitly use 'addTraining' for new entries
  };

  // Return null until initial training data is prepared
  if (!trainingData) return null;

  // Render the training form with the save method
  return <TrainingForm training={trainingData} onSave={saveTrainingToDB} />;
};

export default AddTraining;
